import axios from '../api/axios';

const ReportService = {
    getSalesReport: (startDate, endDate) => {
        return axios.get(`/report/sales?startDate=${startDate}&endDate=${endDate}`);
    },
    getExpenseReport: (startDate, endDate) => {
        return axios.get(`/report/expenses?startDate=${startDate}&endDate=${endDate}`);
    },
    getProfitLossReport: (startDate, endDate) => {
        return axios.get(`/report/profit-loss?startDate=${startDate}&endDate=${endDate}`);
    },
    getStockReport: () => {
        return axios.get('/report/stock');
    },
    getCriticalStockReport: () => {
        return axios.get('/report/critical-stock');
    },
    getCustomerBalanceReport: () => {
        return axios.get('/report/customer-balance');
    }
};

export default ReportService;
